<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content" :class="contentClass">
      <button class="modal-close-btn" @click="$emit('close')">
        <img src="@images/close.svg" class="btn__icon" alt="Закрыть" v-svg-inline>
      </button>
      <slot />
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

defineProps({
  contentClass: { type: String, default: null },
})

defineEmits(['close'])

onMounted(() => { document.body.style.overflow = 'hidden' })
onUnmounted(() => { document.body.style.overflow = '' })
</script>
